import { render, staticRenderFns } from "./CustomerProfiles.vue?vue&type=template&id=c89ff0b4&scoped=true&"
import script from "./CustomerProfiles.vue?vue&type=script&lang=js&"
export * from "./CustomerProfiles.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProfiles.vue?vue&type=style&index=0&id=c89ff0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89ff0b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c89ff0b4')) {
      api.createRecord('c89ff0b4', component.options)
    } else {
      api.reload('c89ff0b4', component.options)
    }
    module.hot.accept("./CustomerProfiles.vue?vue&type=template&id=c89ff0b4&scoped=true&", function () {
      api.rerender('c89ff0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/CustomerProfiles.vue"
export default component.exports